import { render, staticRenderFns } from "./ConfirmModalForFile.vue?vue&type=template&id=46b1b837&scoped=true&"
import script from "./ConfirmModalForFile.vue?vue&type=script&lang=js&"
export * from "./ConfirmModalForFile.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmModalForFile.vue?vue&type=style&index=0&id=46b1b837&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b1b837",
  null
  
)

export default component.exports